import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "src/components/organisms/auth/AuthContext";

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
